import { CONSENT_FORM } from './constants';
import fetchWithRefreshV2 from './fetchWithRefreshV2';

type ConsentFormResponse = {
    success: boolean;

    error?: string;
    url?: string;
};

export default (id: string, signUrl: string): Promise<ConsentFormResponse> =>
    fetchWithRefreshV2(CONSENT_FORM(id), {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'PUT',
        body: JSON.stringify({
            patientSignUrl: signUrl,
        }),
    }).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw new Error('failed');
        }
    });
